export default{
    isLogin: false,
    token: '',
    memberId: '',
}